<template>
  <x-page title="配送人员管理" :loading="loading">
    <template v-if="!loading">
      <div :class="_['list-translate']">
        <div
          v-for="(item, index) in personList"
          :key="index"
          :class="_['person-list-container']"
        >
          <div :class="_['list']">
            <div :class="_['name-phone']">
              <p :class="_.name">{{ item.userName }}</p>
              <p :class="_.phone">{{ item.userPhone }}</p>
            </div>
            <div :class="_['opera']">
              <div
                v-track="{
                  name: '配送人员管理-编辑',
                  id: 'cl9qg1orz001skcugdf0bg2m3',
                }"
                :class="[_['opera-item'], _._hairlineRight]"
                @click="toAdd(item)"
              >
                <img :class="_['opera-icon']" :src="editIcon" alt="" />
                <span>编辑</span>
              </div>
              <div
                v-track="{
                  name: '配送人员管理-删除',
                  id: 'cl9qgr8wa001ukcuger81azf7',
                }"
                :class="_['opera-item']"
                @click="deletePerson(item)"
              >
                <img :class="_['opera-icon']" :src="deleteIcon" alt="" />
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="_['btn']">
        <van-button
          v-track="{
            name: '配送人员管理-新增配送人员',
            id: 'cl9qgrr60001wkcug037d4bxu',
          }"
          :class="_.roundBtn"
          round
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          block
          @click="toAdd"
          >新增配送人员</van-button
        >
      </div>
    </template>
  </x-page>
</template>

<script>
  import deleteIcon from './images/删除.png'
  import editIcon from './images/编辑.png'
  import Vue from 'vue'

  import {
    apiOrderMerchantDeliveryUserDelete,
    apiOrderMerchantDeliveryUserList,
  } from '@/api'
  import { Dialog, Toast } from 'vant'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '配送人员管理',
      })),
    ],
    data() {
      return {
        deleteIcon: deleteIcon,
        editIcon: editIcon,
        personList: [],
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    mounted() {
      this.getPersonList()
    },
    methods: {
      //新增配送人员
      toAdd(item) {
        this.$router.push({
          path: '/manage/deliveryperson/add',
          query: {
            user: JSON.stringify(item),
          },
        })
        this.$destroy()
      },
      async deletePerson(item) {
        Dialog.confirm({
          title: '删除',
          message: '确定删除该配送人员吗？',
        })
          .then(() => {
            // on confirm
            Toast.loading({
              message: '删除中',
              forbidClick: true,
              loadingType: 'spinner',
              duration: 0,
            })
            const promise = apiOrderMerchantDeliveryUserDelete(
              { id: item.id },
              { hasStoreCode: true },
            )
            promise.then(
              () => {
                Toast.clear()
                Toast.success('删除成功')
                this.getPersonList()
              },
              () => {
                console.log('err')
              },
            )
          })
          .catch(() => {
            // on cancel
          })
      },
      //获取配送人员列表
      async getPersonList() {
        const result = await apiOrderMerchantDeliveryUserList(
          {},
          { hasStoreCode: true },
        )
        this.personList = result
      },
    },
  })
</script>

<style lang="scss" module>
  .list-translate {
    // position: relative;
    // top: 0;
    height: calc(100% - 68px);
    overflow: scroll;
    // padding-bottom: 90px;
    .person-list-container {
      padding: 0 12px;
      .list {
        width: calc(100% - 24px);
        height: 46px;
        margin-top: 12px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name-phone {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
          }
          .phone {
            margin-top: 4px;
            font-weight: 400;
            color: #666666;
          }
        }
        .opera {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .opera-item {
            padding: 0 12px;
            display: flex;
            align-items: center;
            .opera-icon {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
  .btn {
    width: calc(100% - 24px);
    position: fixed;
    bottom: 0;
    height: 44px;
    padding: 12px;
    .roundBtn {
      width: 100%;
    }
  }
</style>
